import { dateUtil } from "../../../../utils";

const formatParsedData = (parsedData) => {
  const formattedData = parsedData.map((user, index) => {
    return {
      ...user,
      index: index + 1,
      active: true,
      activeFrom: dateUtil.convertToUTCTimestamp(user?.activeFrom),
      activeTo: dateUtil.convertToUTCTimestamp(user?.activeTo, true),
      stringActiveFrom: user?.activeFrom,
      stringActiveTo: user?.activeTo,
      id: user?.email,
      firstName: user?.firstName,
      lastName: user?.lastName,
      group:
        user?.group && user?.group?.split(",")?.length > 0 ? user?.group?.split(",") : undefined,
      market:
        user?.market && user?.market?.split(",")?.length > 0 ? user?.market?.split(",") : undefined,
      locationName:
        user?.locationName && user?.locationName?.split(",")?.length > 0
          ? user?.locationName?.split(",")
          : undefined,
      appType:
        user?.appType && user?.appType?.split(",")?.length > 0
          ? user?.appType?.split(",")
          : undefined,
      correct: !!(
        user?.email &&
        user?.firstName &&
        user?.lastName &&
        user?.group &&
        user?.activeFrom &&
        user?.activeTo &&
        user?.market &&
        user?.appType
      )
    };
  });

  return formattedData;
};

const formatRecords = (records) => {
  return records.map((record) => {
    delete record["index"];
    delete record["correct"];
    delete record["id"];
    delete record["active"];
    delete record["stringActiveFrom"];
    delete record["stringActiveTo"];
    delete record["__parsed_extra"];

    return record;
  });
};

export const formatUtils = {
  formatParsedData,
  formatRecords
};
